import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import RegenerateIdsButton from './RegenerateIdsButton';

const SurveyEditorItemHeader = ({setFieldValue, values}) => (
    <>
        <div className="page-header d-flex flex-column justify-content-center">
            <FormattedMessage {...messages.surveys.form.title.surveySettings} />
        </div>
        <RegenerateIdsButton editor={values.editor} setFieldValue={setFieldValue} />
    </>
);

export default SurveyEditorItemHeader;
